import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import * as Connection from "./../libs/connections";

import Preloader from "./../components/global/Preloader";
import HeroBannerSmall from "../components/HeroBannerSmall";
import SectionTerms from "../components/SectionsTerms";

import heroBackground from "../assets/header/header-regulamin.svg";

export default class TermsAndConditionsPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      error: false,
      headertext: "",
      elements: []
    };
  }

  async componentDidMount() {
    try {
      await Connection;
      const response = await Connection.getSinglePage("regulamin");
      this.setState({
        loading: false,
        headertext: response.title.rendered,
        elements: response.acf.elements
      });
    } catch (err) {
      this.setState({
        error: true
      });
    }
  }

  render() {
    if (!this.state.error) {
      return (
        <div className="page-termsandconditions">
          <Preloader global loading={this.state.loading} />
          {this.state.headertext && (
            <HeroBannerSmall centerForce={true} changeOpacity={true} backgroundImage={heroBackground} headerText={this.state.headertext} />
          )}
          {this.state.elements && <SectionTerms elements={this.state.elements} />}
        </div>
      );
    } else {
      return <Redirect to="/error" />;
    }
  }
}
